import { render, staticRenderFns } from "./PopBoxInner.vue?vue&type=template&id=4730dd20&"
import script from "./PopBoxInner.vue?vue&type=script&lang=js&"
export * from "./PopBoxInner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports